/**
 * Date format preset options
 */
export type DateFormatPreset = "short" | "medium" | "long" | "full";

/**
 * Time format preset options
 */
export type TimeFormatPreset = "short" | "medium";

/**
 * Shared date format presets used by date formatters
 */
export const dateFormatPresets: Record<
  DateFormatPreset,
  Intl.DateTimeFormatOptions
> = {
  short: { year: "numeric", month: "2-digit", day: "2-digit" },
  medium: { year: "numeric", month: "short", day: "2-digit" },
  long: { year: "numeric", month: "long", day: "2-digit" },
  full: { weekday: "long", year: "numeric", month: "long", day: "2-digit" },
};

/**
 * Shared time format presets used by time formatters
 */
export const timeFormatPresets: Record<
  TimeFormatPreset,
  Intl.DateTimeFormatOptions
> = {
  short: { hour: "2-digit", minute: "2-digit" },
  medium: { hour: "2-digit", minute: "2-digit", second: "2-digit" },
};
